module.exports = __webpack_public_path__ + "img/night-middle-bg_en.278167cb.png";